import styled, { css, keyframes } from "styled-components";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";

export const Container = styled.div`
  display: flex;
  gap: 7px;
  padding: 0 16px 0px 16px;
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const CloseIconWrapper = styled.div`
  height: 100%;
  width: 44px;
  transition: opacity 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const CloseIcon = styled(CloseSvg)``;

export const SearchFilter = styled.div`
  display: flex;
  height: 32px;
  padding: 0 8px 0 12px;
  align-items: center;
  border-radius: 8px;

  border: 1px solid #3f3f46;
  background: #151517;

  cursor: ${(props) => (props.$expanded ? "default" : "pointer")};

  max-width: ${(props) => (props.$alwaysExpanded ? "440px" : "unset")};

  width: ${(props) =>
    props.$alwaysExpanded ? "100%" : props.$expanded ? "230px" : "44px"};
  transition: width 0.6s cubic-bezier(0.23, 1, 0.32, 1), background 0.3s ease,
    opacity 0.3s ease;

  @media (max-width: 768px) {
    min-width: ${(props) => (props.$expanded ? "230px" : "44px")};
    transition: min-width 0.6s cubic-bezier(0.23, 1, 0.32, 1),
      background 0.3s ease, opacity 0.3s ease;
  }

  @media (max-width: 480px) {
    width: ${(props) =>
      props.$alwaysExpanded ? "100%" : props.$expanded ? "230px" : "44px"};
  }
  position: relative;
`;

export const StyledInput = styled.input`
  background-color: blue;
  width: 100%;
  background-color: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.07px;
  padding-left: 30px;
  z-index: 2;

  &::placeholder {
    color: #fff;
    opacity: 0.5;
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#3F3F46" : "#151517")};
  border-radius: 8px;
  border: 1px solid #3f3f46;

  cursor: pointer;

  ${({ $animation }) =>
    $animation &&
    css`
      background: linear-gradient(
        90deg,
        #1a1a1a 0px,
        #2a2a2a 40px,
        #1a1a1a 80px
      );
      background-size: 468px 100%;
      animation: ${shimmer} 3s infinite linear, ${pulse} 2s infinite ease-in-out;
    `}
`;

export const CategoryText = styled.p`
  color: ${({ $selected }) => ($selected ? "#fff" : "#fff")};
  font-family: DM Sans;
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  line-height: 18px;
  letter-spacing: -0.07px;
`;
